module.exports = __webpack_public_path__ + "img/goldbadge.829eddac.svg";